// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-error-message {
  display: flex;
  align-items: center;
  position: relative;

  color: var(--input-indicator-color-error);

  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 14px;

  padding-top: 1px;
  margin-top: 4px;
  padding-bottom: 4px;
}

.input-error-message .text {
  line-height: 19px;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.input-error-message.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,yCAAyC;;EAEzC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;;EAEjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".input-error-message {\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  color: var(--input-indicator-color-error);\n\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 14px;\n\n  padding-top: 1px;\n  margin-top: 4px;\n  padding-bottom: 4px;\n}\n\n.input-error-message .text {\n  line-height: 19px;\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
